import React from "react";
import { Alert, Link } from "@mui/material";

const GatewayExistsAlert = ({ exists, checking, url, label }) => {
  if (checking) {
    return <Alert severity="info">Checking if this record already exists in Gateway...</Alert>;
  }

  if (!exists) {
    return null;
  }

  return (
    <Alert severity="warning">
      This missing record already exists in Gateway and may be stale.
      {url ? (
        <>
          {" "}
          <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover">
            Open existing {label || "record"}
          </Link>
          .
        </>
      ) : null}
    </Alert>
  );
};

export default GatewayExistsAlert;
